module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Add a new maintenance record"},"de":{"title":"Neuen Wartungssatz hinzufügen"},"fr":{"title":"Ajouter un nouvel de maintenance"},"it":{"title":"Aggiungere un nuovo record di manutenzione"}}')
  delete Component.options._Ctor
}
